<template>
  <div class="grid grid-cols-6 md:grid-cols-auto max-[861px]:grid-cols-2  gap-4">
    <button
      v-for="button in visibleButtons"
      :key="button.key || button.label"
      class="!h-[66px] flex-grow  flex justify-center items-center p-5 gap-1.5 flex-1 rounded-[6px] border cursor-pointer text-center"
      :class="[
        button.isEmergency
          ? 'border-[#F2E7F9] text-[#FFF] bg-[#9B237B]'
          : 'border-[1px] border-[#B7B2B5] bg-[#FFF] text-[#1F1D1F]',
      ]"
      @click="handleButtonClick(button)"
    >
      <div class="flex gap-2 items-center">
        <component
          v-if="button.icon"
          class="w-[21px] h-[20px]"
          :class="!button.isEmergency ? 'text-primary':''"
          :is="button.icon"
        />
        <div>{{ button.label }}</div>
      </div>
    </button>
  </div>
</template>

<script>
import GISMapIcon from '@/assets/icons/GISMap.icon.vue';
import { mapStores } from 'pinia';
import { useAuthStore } from '@/pinia/authStore';

export default {
  name: 'ButtonGroup',
  components: { GISMapIcon },
  props: {
    buttons: { type: Array, required: true },
  },
  computed: {
    ...mapStores(useAuthStore),
    visibleButtons() {
      return (this.buttons || []).filter(this.isVisible);
    },
  },
  methods: {
    // ถ้าปุ่มกำหนด roles -> เช็ค role, ถ้ากำหนด perm -> เช็คสิทธิ์, ถ้าไม่กำหนดอะไร -> โชว์
    isVisible(btn) {
      if (btn?.roles) {
        // roles รับได้ทั้งเลขเดียวหรืออาเรย์ของเลข role
        return this.authStore.hasRole(btn.roles);
      }
      if (btn?.perm) {
        // perm เป็นชื่อสิทธิ์ เช่น 'VIEW_SHELTER'
        return this.authStore.can(btn.perm);
      }
      return true;
    },
    handleButtonClick(button) {
      if (typeof button.action === 'function') button.action();
      else if (button.route) this.$router.push(button.route);
      else console.log(button.label);
      this.$emit('button-click', button);
    },
  },
};
</script>
